////
/// ============================================================================
/// COMPONENT / PhotoSwipe
/// ============================================================================
///
/// @group components
////

import PhotoSwipeLightbox from 'photoswipe/lightbox';
import PhotoSwipeDynamicCaption from 'photoswipe-dynamic-caption-plugin';

export default () => {
    let element = document.querySelector('.js-lightbox');

    if (!element) {
        return;
    }

    // Photoswipe
    const zoom = '<svg aria-hidden="true" class="pswp__icn"><use xlink:href="' + m6e.spriteUrl + '#icon--search"></use></svg>';
    const close = '<svg aria-hidden="true" class="pswp__icn"><use xlink:href="' + m6e.spriteUrl + '#icon--close"></use></svg>';
    const arrow = '<svg aria-hidden="true" class="pswp__icn"><use xlink:href="' + m6e.spriteUrl + '#icon--arrow"></use></svg>';

    const options = {
        arrowNextSVG: arrow,
        arrowPrevSVG: arrow,
        children: 'a',
        closeSVG: close,
        gallery: '.js-lightbox',
        loop: false,
        padding: { top: 20, bottom: 20, left: 20, right: 20 },
        preload: [1, 4],
        zoomSVG: zoom,

        arrowPrevTitle: 'Immagine precedente',
        arrowNextTitle: 'Immagine successiva',
        closeTitle: 'Chiudi',
        errorMsg: 'Immagine non caricata',
        indexIndicatorSep: ' di ',

        pswpModule: () => import('photoswipe'),
    };

    const lightbox = new PhotoSwipeLightbox(options);

    const captionPlugin = new PhotoSwipeDynamicCaption(lightbox, {
        type: 'auto',
    });

    lightbox.init();
};
